import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../../../stores/CurrentUserStore'
import { ProductListing } from './ProductListing'
import { Skeleton } from 'antd'

interface State {
  locationId: number | null
  errorMessage?: string
  isLoading: boolean
}

interface Props {
  currentCompanyStore: CurrentCompanyStore
  currentUserStore: CurrentUserStore
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class WooCommerceProducts extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      locationId: null,
      isLoading: false,
    }
  }

  componentDidMount() {
    this.props.currentCompanyStore!.getLocations()
  }

  render() {
    const locations = this.props.currentCompanyStore!.locations

    if (!locations) {
      return (
        <div>
          <Skeleton active />
        </div>
      )
    }

    return <ProductListing />
  }
}
